(function () {
  document
    .querySelectorAll('[data-shipping-estimate] [data-shipping-message]')
    .forEach(function (node) {
      if (!node) return
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
        weekday: 'short'
      })
      let timer
      function update () {
        const parts = fmt.formatToParts(new Date())
        let hour = 0
        let minute = 0
        let weekday = ''
        parts.forEach(function (part) {
          if (part.type === 'hour') hour = parseInt(part.value, 10)
          if (part.type === 'minute') minute = parseInt(part.value, 10)
          if (part.type === 'weekday') weekday = part.value
        })
        const isSunday = weekday === 'Sun'
        if (!isSunday && hour < 15) {
          const remaining = (15 - hour) * 60 - minute
          if (remaining <= 180) {
            const hours = Math.floor(remaining / 60)
            const mins = remaining % 60
            const time = hours > 0 ? hours + ' hr ' + mins + ' min' : mins + ' min'
            node.innerHTML =
              '<strong class="text-pjs-text-500">Ships today</strong> · order within ' +
              '<strong class="text-pjs-primary-500">' +
              time +
              '</strong>'
          } else {
            node.innerHTML = '<strong class="text-pjs-text-500">Ships same day</strong>'
          }
        } else {
          const nextDay = (weekday === 'Sat' && hour >= 15) || isSunday ? 'Monday' : 'tomorrow'
          node.innerHTML = 'Ships <strong class="text-pjs-text-500">' + nextDay + '</strong>'
          clearInterval(timer)
        }
      }
      update()
      timer = setInterval(update, 60000)
    })
})()
